<div class="footer">
    <span>G.P. Automazioni s.r.l. - Partita Iva e C.F. 12729030010</span>
</div>
